import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-sparkle, message, like, heart"><path d="M3.75 3.75H20.25V18.25H15.0155L11.9979 20.75L9.0155 18.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.399 7.25H11.599L10.599 9.85L7.99902 10.85V11.65L10.599 12.65L11.599 15.25H12.399L13.399 12.65L15.999 11.65V10.85L13.399 9.85L12.399 7.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubbleSparkle;
